import { HrmsEmployeeDetailsDto } from "@gtpl/shared-models/masters";
import { EmployeeLeavesDTO } from "./employee-leaves.dto";
import { EmployeeLeaves } from "../entity/employee-leaves.entity";

export class EmployeeLeavesAdapter{
    
    convertDtoToEntity(dtoObj: HrmsEmployeeDetailsDto, isUpdate: boolean = false): EmployeeLeaves{
        try{

            if(isUpdate){

            }
            else{
                const entityObj = new EmployeeLeaves();
                // entityObj.employeeId = dtoObj.employeeId;
                // entityObj.year = "";
                // entityObj.leavesAlloted = dtoObj.leavesAlloted;
                // entityObj.leavesAvailable = dtoObj.leavesAvailable;
                // entityObj.leavesUsed = dtoObj.leavesUsed;
                // entityObj.typeOfLeave = dtoObj.typeOfLeave;
                // entityObj.dateTime = dtoObj.dateTime;
                
                // if(isUpdate){
                //     entityObj.updatedUser = dtoObj.updatedUser;
                // }else {
                //     entityObj.isActive = true;
                //     entityObj.createdUser = dtoObj.createdUser;
                // }
                return entityObj;

            }
            
        }catch(error){
            throw error;
        }
    }

    convertEntityToDto(entityObj: EmployeeLeaves): EmployeeLeavesDTO{
        
            const dtoObj = new EmployeeLeavesDTO();
            dtoObj.employeeLeavesId = entityObj.employeeLeavesId;
            dtoObj.employeeId = entityObj.employeeId;
            dtoObj.year = entityObj.year;
            dtoObj.typeOfLeave = entityObj.typeOfLeave;
            dtoObj.leavesUsed = entityObj.leavesUsed;
            dtoObj.leavesAvailable = entityObj.leavesAvailable;
            dtoObj.leavesAlloted = entityObj.leavesAlloted;
            dtoObj.dateTime = entityObj.dateTime;
            dtoObj.isActive = entityObj.isActive;
            dtoObj.createdAt = entityObj.createdAt;
            dtoObj.createdUser = entityObj.createdUser;
            dtoObj.updatedAt = entityObj.updatedAt;
            dtoObj.updatedUser = entityObj.updatedUser;
            dtoObj.versionFlag = entityObj.versionFlag;
            return dtoObj;
    }
}